export const FILE_ACCEPT = ".xlsx,.csv";

// An opening balance runs to about 5,200 lines in one warehouse; the API accepts up to 10,000.
export const MAX_IMPORT_ROWS = 10000;

// Past this many lines the manual edit form (one editable grid row per line) gets slow, so the
// edit page is closed and the file-based cost update is offered instead.
export const MAX_MANUAL_EDIT_LINES = 500;

// What the stock columns can hold: DECIMAL(10,0) for quantity, DECIMAL(10,2) for cost.
export const MAX_QUANTITY = 9999999999;
export const MAX_COST_PER_UNIT = 99999999.99;

export const FileColumnEnum = Object.freeze({
  SKU: "sku",
  QUANTITY: "quantity",
  COST_PER_UNIT: "costPerUnit",
});

export const FileColumnLabel = Object.freeze({
  [FileColumnEnum.SKU]: "SKU",
  [FileColumnEnum.QUANTITY]: "Qty",
  [FileColumnEnum.COST_PER_UNIT]: "Harga per Unit",
});

// Header spellings accepted for each column, compared after lower-casing and dropping everything
// that is not a letter or digit ("Harga per Unit" -> "hargaperunit").
export const FileColumnAliases = Object.freeze({
  [FileColumnEnum.SKU]: ["sku", "kodesku"],
  [FileColumnEnum.QUANTITY]: ["qty", "quantity", "jumlah", "kuantitas"],
  [FileColumnEnum.COST_PER_UNIT]: [
    "hargaperunit",
    "harga",
    "hargasatuan",
    "biayasatuan",
    "costperunit",
    "cost",
  ],
});
